import { useId } from 'preact/compat';

export function useUniqueId(prefix = '') {
  const id = useId();

  return `wbtxReviews${prefix}${id}`;
}
